import { render, staticRenderFns } from "./BotaoVisualizarFormulario.vue?vue&type=template&id=73a1cc00&scoped=true&"
import script from "./BotaoVisualizarFormulario.vue?vue&type=script&lang=js&"
export * from "./BotaoVisualizarFormulario.vue?vue&type=script&lang=js&"
import style0 from "./BotaoVisualizarFormulario.vue?vue&type=style&index=0&id=73a1cc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1cc00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex})
